import type { Vector2 } from 'three';

import EventManager from './EventManager';

enum EventNames {
  ZOOM,
  MOVE,
}

const heatMapEventManager = new EventManager<EventNames>();

export const HeatMapEvents = {
  ZOOM: heatMapEventManager.createEvent<{
    point: Vector2;
    oldZoomFraction: number;
    newZoomFraction: number;
  }>(EventNames.ZOOM),
  MOVE: heatMapEventManager.createEvent<{
    point: Vector2;
    zoomFraction: number;
    direction: 'left' | 'right';
  }>(EventNames.MOVE),
};

export default heatMapEventManager;
